import { AnimatePresence, motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function Layout({ children }) {
  const location = useLocation();

  return (
    <SmoothScroll>
      <div className="grain" aria-hidden="true" />
      <Navbar />
      <AnimatePresence mode="wait">
        <motion.main
          key={location.pathname}
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -8 }}
          transition={{ duration: 0.5, ease: [0.76, 0, 0.24, 1] }}
        >
          {children}
        </motion.main>
      </AnimatePresence>
      <Footer />
    </SmoothScroll>
  );
}
